import styled from "styled-components";

export const TablistContainer = styled.section`
    display: flex;
    flex-direction: column;
    position: relative;
    padding-top: 70px;
    background-color: ${(props) => props.theme.colors.lightBg};

    h2 {
        margin: auto;
        margin-bottom: 16px;
        font-size: 48px;
        line-height: 64px;
        font-weight: 700;
        text-align: center;
    }
    p {
        margin-left: auto;
        margin-right: auto;
        font-size: 18px;
        line-height: 32px;
        font-weight: 500;
        text-align: center;
    }
    .subheader {
        margin-bottom: 48px;
        margin-top: 0px;
    }
`;

export const TablistWrapper = styled.div`
    max-width: 100%;
`;
export const Tabnav = styled.div`
    width: auto;
    position: relative;
    overflow: hidden;
    height: 54px;
    z-index: 1;
    margin-bottom: 12px;
    text-align: center;   
    font-size: 17px;
`;
export const TabnavItems = styled.ul`
    margin: 0;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    padding: 0 0 3.1764705882em;

    &::before, &::after  {
        content: "";
        display: inline-block;
        width: 34px;
    }

    li {
        display: inline-block;
        padding-left: 40px;
        border-bottom: 1px solid #c7c7c7;
        list-style: none;
        outline: none;
    }
    li:first-child {
        padding-left: 0;
    }

    li>a {
        font-size: 17px;
        line-height: 1;
        padding: 9px 0 11px;
        margin-top: 2px;
        margin-bottom: 4px;
        color: #bcbcbc;
        text-align: left;
        text-decoration: none;
        display: block;
        position: relative;
        z-index: 0;
        font-weight: 700;
        padding-bottom: 0;
        cursor: pointer;
    }

    li>a:hover {
        color: ${(props) => props.theme.colors.buttonPrimary};
    }

    li>.current {
        pointer-events: none;
        color: ${(props) => props.theme.colors.buttonPrimary};
        text-decoration: none;
        cursor: default;
        z-index: 10;
    }
    li>.current::after {
        border-bottom-color: ${(props) => props.theme.colors.buttonPrimary};
        border-bottom-width: 2px;
    }

    li>a::after {
        left: 0;
        position: absolute;
        bottom: -5px;
        width: 100%;
        border-bottom: 1px solid transparent;
        content: "";
    }
`;